<template>
  <div class="d-flex align-center" @click.stop>
    <div class="mr-2 text-center">
      <InputFormatadorDeValor
        v-model="linha.sugestao_compra_em_quantidade"
        :removerValorIrrelevante="true"
        centralizar
        :sufixo="linha.unidade_compra"
        class="input-regular font-12"
        :disabled="DISABILITAR_EDICAO_INPUT"
        @focus="$event.target.select()"
        @keyup.enter="adicionarCategoriaNoCarrinho"
        @keydown.prevent.up="incrementarSugestao"
        @keydown.prevent.down="decrementarSugestao"
      />
    </div>

    <v-spacer />

    <template>
      <ValidaLoteMinimo
        v-if="!LOTE_MINIMO_VALIDO"
        v-model="linha.sugestao_compra_em_quantidade"
        :lote-minimo="linha.lote_minimo"
      />

      <v-btn v-else :disabled="DISABILITAR_EDICAO_INPUT || linha.sugestao_compra_em_quantidade <= 0" icon @click="adicionarCategoriaNoCarrinho">
        <v-icon>mdi-cart</v-icon>
      </v-btn>
    </template>
  </div>
</template>

<script>
import InputFormatadorDeValor from "../../../utils/InputFormatadorDeValor.vue";
import ValidaLoteMinimo from "../../ValidaLoteMinimo";

import {adicionarCategoriaNoCarrinho} from "../../../../api/compraPorDepartamentos/ProdutosPedidoCompraTipo.js"

import {NIVEIS_DE_EXPANCAO} from "../../../utils/dataTable/sysDataTableDepartamentos/NiveisDeExpancao.js";
import {data_table_departamentos_carregando_dados} from "../../../utils/dataTable/sysDataTableDepartamentos/CarregandoDados.js";
import {parametros_rota} from "../helpers/ParametrosRota.js";

import {mapGetters} from "vuex";
import {logout} from "../../../../helpers";

export default {
  name: "AdicionaNoCarrinho",
  mixins: [data_table_departamentos_carregando_dados, parametros_rota],
  components: {
    ValidaLoteMinimo,
    InputFormatadorDeValor
  },
  props: {
    linha: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    NIVEIS_DE_EXPANCAO
  }),
  computed: {
    ...mapGetters({
      'atualizarPedidoCarrinhoCallback': 'carrinhoDepartamentos/atualizarPedidoCarrinhoCallback'
    }),
    LOTE_MINIMO_VALIDO() {
      if (!this.linha.lote_minimo) return false;

      const qtd_compra = this.linha.sugestao_compra_em_quantidade.toFixed(4);
      const modulo = Number((qtd_compra % this.linha.lote_minimo).toFixed(4));

      return (modulo == 0 || modulo == this.linha.lote_minimo);
    },
    CATEGORIA_REQUISICAO() {
      const {
        idcategoria,
        tipo_compra,
        sugestao_compra_em_quantidade: quantidade,
        sugestao_compra_em_quantidade_fixa: sugerido,
      } = this.linha;

      return {
        quantidade,
        sugerido,
        tipo_compra,
        idcategoria
      }
    },
    DISABILITAR_EDICAO_INPUT() {
      return this.data_table_departamentos_carregando_dados || this.PARAMETROS.card === 'itens_em_transito';
    }
  },
  methods: {
    adicionarCategoriaNoCarrinho() {
      if (!this.LOTE_MINIMO_VALIDO || this.linha.sugestao_compra_em_quantidade <= 0) return;

      const requisicao = {
        grupo_compra: this.grupo_compra,
        filial_compra: this.filial_compra,
        departamento_compra: this.departamento_compra,
        categorias: this.CATEGORIA_REQUISICAO
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        adicionarCategoriaNoCarrinho(requisicao).then(this.categoriaAdicionadaComSucesso).catch(logout)
      );
    },
    categoriaAdicionadaComSucesso() {
      this.$emit('produto-adicionado-carrinho', this.linha)
    },
    incrementarSugestao() {
      this.linha.sugestao_compra_em_quantidade++;
    },
    decrementarSugestao() {
      this.linha.sugestao_compra_em_quantidade--;
    }
  }
}
</script>

<style scoped>

</style>
